import { createAsyncThunk } from '@reduxjs/toolkit';
import { G as GetHCaptcha } from '../../GetHCaptcha-IDk4oNcr.js';
import { b as publicMutate } from '../../requestsCollection-oNJgKLxK.js';
import { extractErrorMessage } from '../../utils/error.js';
import '../../utils/logToSlack.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-a4IKjS7g.js';
import '../../utils/currency.js';
import 'react';
import '../../context/index.js';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import 'next/router';
import '../../helpers-qU2Vf3ni.js';
import 'lodash';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/cookies.js';
import '../../cookies-l-jEMp6P.js';
import '../../utils/isBot.js';
import '../../utils/fetchPolicyLookup.js';
import '../../serverErrors-JVvpO9sB.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';

const getCaptcha = createAsyncThunk('captcha/getCaptcha', async (_, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data } = await publicMutate(apolloConfig(), {
            mutation: GetHCaptcha,
        });
        return data.hCaptcha;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});

export { getCaptcha };
//# sourceMappingURL=thunks.js.map
